import { SET_SETTING_CONFIG } from '../types/shopSetting'

const initState = {
  shopSetting: {},
  lastModified: new Date().getTime(),
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_SETTING_CONFIG:
      return { ...state, shopSetting: action.payload, lastModified: new Date().getTime() }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shopSetting.js